var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartphoneMannServiceweltCombi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1423.7 972.7",
    style: {
      enableBackground: "new 0 0 1423.7 972.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#137F7B;}\n\t.st1{fill:#DADDDF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#B2B6BB;}\n\t.st4{opacity:0.2;enable-background:new    ;}\n\t.st5{fill:#006666;}\n\t.st6{opacity:5.000000e-02;enable-background:new    ;}\n\t.st7{opacity:0.3;}\n\t.st8{opacity:0.3;enable-background:new    ;}\n\t.st9{opacity:0.3;fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;enable-background:new    ;}\n\t.st10{fill:#F4F4F4;}\n\t.st11{opacity:0.15;enable-background:new    ;}\n\t.st12{fill:#FC9D9D;}\n\t.st13{fill:#3F4249;}\n\t.st14{opacity:0.5;enable-background:new    ;}\n\t.st15{fill:#21252B;}\n\t.st16{opacity:0.15;}\n\t.st17{opacity:0.4;fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-miterlimit:10;enable-background:new    ;}\n\t\n\t\t.st18{opacity:0.4;fill:none;stroke:#FFFFFF;stroke-width:1.03;stroke-linecap:round;stroke-miterlimit:10;enable-background:new    ;}\n\t.st19{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}\n\t.st20{opacity:0.4;}\n\t\n\t\t.st21{opacity:0.15;fill:none;stroke:#000000;stroke-width:0.83;stroke-linecap:round;stroke-miterlimit:10;enable-background:new    ;}\n\t.st22{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\n\t.st23{fill:#FFFFFF;stroke:#B2B6BB;stroke-width:2;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 731.4,
    cy: 832.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 731.4,
    cy: 784.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 731.4,
    cy: 736.1,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 731.4,
    cy: 687.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 731.4,
    cy: 639.5,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 779.7,
    cy: 832.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 779.7,
    cy: 784.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 779.7,
    cy: 736.1,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 779.7,
    cy: 687.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 779.7,
    cy: 639.5,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 828,
    cy: 832.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 828,
    cy: 784.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 828,
    cy: 736.1,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 828,
    cy: 687.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 828,
    cy: 639.5,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 876.3,
    cy: 832.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 876.3,
    cy: 784.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 876.3,
    cy: 736.1,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 876.3,
    cy: 687.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 876.3,
    cy: 639.5,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 924.6,
    cy: 832.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 924.6,
    cy: 784.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 924.6,
    cy: 736.1,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 924.6,
    cy: 687.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 924.6,
    cy: 639.5,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 972.9,
    cy: 832.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 972.9,
    cy: 784.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 972.9,
    cy: 736.1,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 972.9,
    cy: 687.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 972.9,
    cy: 639.5,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1021.1,
    cy: 832.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1021.1,
    cy: 784.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1021.1,
    cy: 736.1,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1021.1,
    cy: 687.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1021.1,
    cy: 639.5,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1069.4,
    cy: 832.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1069.4,
    cy: 784.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1069.4,
    cy: 736.1,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1069.4,
    cy: 687.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1069.4,
    cy: 639.5,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1117.7,
    cy: 832.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1117.7,
    cy: 784.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1117.7,
    cy: 736.1,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1117.7,
    cy: 687.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1117.7,
    cy: 639.5,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1166,
    cy: 832.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1166,
    cy: 784.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1166,
    cy: 736.1,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1166,
    cy: 687.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1166,
    cy: 639.5,
    r: 3.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1019.5,650.6c62.1,0,112.6,50.6,112.6,112.6s-50.6,112.6-112.6,112.6s-112.6-50.6-112.6-112.6 S957.4,650.6,1019.5,650.6 M1019.5,648.2c-63.5,0-115,51.5-115,115s51.5,115,115,115s115-51.5,115-115S1083,648.2,1019.5,648.2 L1019.5,648.2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.7,360H152.5c-2.5,0-4.9,1-6.6,2.7c-1.8,1.8-2.7,4.1-2.7,6.6v38.2c0,2.5,1,4.9,2.7,6.6 c1.8,1.8,4.1,2.7,6.6,2.7h6.3l0.3,21l14.8-21h187.8c2.5,0,4.9-1,6.6-2.7c1.8-1.8,2.7-4.1,2.7-6.6v-38.3c0-2.5-1-4.9-2.8-6.6 C366.6,361,364.2,360,361.7,360L361.7,360z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M350.4,379.4H163.8v4.5h186.6L350.4,379.4L350.4,379.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M196.9,393h-33.1v4.5h33.1V393z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M285.3,393h-81.1v4.5h81.1V393z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.5,264h209.2c2.5,0,4.9,1,6.6,2.7s2.7,4.1,2.7,6.6v38.2c0,2.5-1,4.9-2.7,6.6c-1.8,1.8-4.1,2.7-6.6,2.7h-6.3 l-0.3,21l-14.9-21H75.5c-2.5,0-4.9-1-6.6-2.7c-1.8-1.8-2.7-4.1-2.7-6.6v-38.3c0-2.5,1-4.9,2.8-6.6C70.6,265,73,264,75.5,264z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.8,287.9h186.6v-4.5H86.8V287.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M240.2,301.6h33.1V297h-33.1L240.2,301.6L240.2,301.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151.8,301.6h81.1V297h-81.1L151.8,301.6L151.8,301.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.5,456h209.2c2.5,0,4.9,1,6.6,2.7c1.8,1.8,2.7,4.1,2.7,6.6v38.2c0,2.5-1,4.9-2.7,6.6 c-1.8,1.8-4.1,2.7-6.6,2.7h-6.3l-0.3,21l-14.9-21H75.5c-2.5,0-4.9-1-6.6-2.7c-1.8-1.8-2.7-4.1-2.7-6.6v-38.3c0-2.5,1-4.9,2.8-6.6 C70.6,457,73,456,75.5,456L75.5,456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.8,479.9h186.6v-4.5H86.8V479.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M240.2,493.6h33.1V489h-33.1L240.2,493.6L240.2,493.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151.8,493.6h81.1V489h-81.1L151.8,493.6L151.8,493.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1073.3,61.1H546c-5.7,0-10.4,4.7-10.4,10.4v757.6c0,5.8,4.7,10.4,10.4,10.4h527.3c5.7,0,10.4-4.7,10.4-10.4 V71.5C1083.7,65.8,1079.1,61.1,1073.3,61.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1060.7,60.5H533.4c-5.7,0-10.4,4.7-10.4,10.4v757.6c0,5.8,4.7,10.4,10.4,10.4h527.3c5.7,0,10.4-4.6,10.4-10.4 V70.9C1071.1,65.2,1066.4,60.5,1060.7,60.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M545,60.1h527.7c1.4,0,2.7,0.3,4,0.8s2.4,1.3,3.4,2.3s1.7,2.1,2.3,3.4c0.5,1.3,0.8,2.6,0.8,4V123H534.6V70.6 c0-2.8,1.1-5.4,3-7.4C539.6,61.2,542.2,60.1,545,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M545,60.1h527.7c1.4,0,2.7,0.3,4,0.8s2.4,1.3,3.4,2.3s1.7,2.1,2.3,3.4c0.5,1.3,0.8,2.6,0.8,4V123H534.6V70.6 c0-2.8,1.1-5.4,3-7.4C539.6,61.2,542.2,60.1,545,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M533,60.1h527.7c2.8,0,5.4,1.1,7.3,3c1.9,2,3,4.6,3,7.4V123H522.6V70.6c0-1.4,0.3-2.7,0.8-4s1.3-2.4,2.3-3.4 s2.1-1.7,3.4-2.3C530.3,60.4,531.6,60.1,533,60.1L533,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M561.4,162.5h473c1.6,0,3.1,0.6,4.2,1.8c1.1,1.1,1.8,2.7,1.8,4.2V459c0,1.6-0.6,3.1-1.8,4.2 c-1.1,1.1-2.7,1.8-4.2,1.8h-473V162.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1028.6,162.5H561.2c-3.2,0-5.8,2.6-5.8,5.8v291c0,3.2,2.6,5.8,5.8,5.8h467.4c3.2,0,5.8-2.6,5.8-5.8v-291 C1034.4,165.1,1031.8,162.5,1028.6,162.5z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M548.6,98.4c3.8,0,6.9-3.1,6.9-6.9s-3.1-6.9-6.9-6.9c-3.8,0-6.9,3.1-6.9,6.9S544.7,98.4,548.6,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M573,98.4c3.8,0,6.9-3.1,6.9-6.9s-3.1-6.9-6.9-6.9c-3.8,0-6.9,3.1-6.9,6.9S569.2,98.4,573,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M597.4,98.4c3.8,0,6.9-3.1,6.9-6.9s-3.1-6.9-6.9-6.9c-3.8,0-6.9,3.1-6.9,6.9 C590.6,95.3,593.6,98.4,597.4,98.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M984,88.1H637.9V95H984V88.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M960.5,304.4h-346v6.9h346.1L960.5,304.4L960.5,304.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M784.8,289.9H614.5v6.9h170.4L784.8,289.9L784.8,289.9z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1015.7,84.7h26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1015.7,91.5h26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1015.7,98.4h26"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M701.6,487.3l4.3,8.7l9.6,1.4l-6.9,6.8l1.6,9.5l-8.6-4.5l-8.6,4.5l1.6-9.5l-6.9-6.8l9.6-1.4L701.6,487.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M749.2,487.3l4.3,8.7l9.6,1.4l-6.9,6.8l1.6,9.5l-8.6-4.5l-8.6,4.5l1.6-9.5l-6.9-6.8l9.6-1.4L749.2,487.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M796.8,487.3l4.3,8.7l9.6,1.4l-6.9,6.8l1.6,9.5l-8.6-4.5l-8.6,4.5l1.6-9.5l-6.9-6.8l9.6-1.4L796.8,487.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M844.5,487.3l4.3,8.7l9.6,1.4l-6.9,6.8l1.6,9.5l-8.6-4.5l-8.6,4.5l1.6-9.5l-6.9-6.8l9.6-1.4L844.5,487.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M892.1,487.3l4.3,8.7l9.6,1.4l-6.9,6.8l1.6,9.5l-8.6-4.5l-8.6,4.5l1.6-9.5l-6.9-6.8l9.6-1.4L892.1,487.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M892.6,509.2l-8.6,4.5l1.6-9.5l-6.9-6.8l9.6-1.4l4.3-8.7L892.6,509.2L892.6,509.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M946.6,535.9H646.2v6.9h300.4V535.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M845.2,551.2h-199v6.9h199V551.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M602.5,531.9c-3-3-6.8-5-11-5.9c-4.2-0.8-8.5-0.4-12.4,1.2c-3.9,1.6-7.3,4.4-9.6,7.9 c-2.4,3.5-3.6,7.7-3.6,11.9s1.3,8.4,3.6,11.9s5.7,6.3,9.6,7.9c3.9,1.6,8.2,2,12.4,1.2c4.1-0.8,8-2.9,11-5.9c2-2,3.6-4.3,4.7-6.9 c1.1-2.6,1.6-5.4,1.6-8.2s-0.6-5.6-1.6-8.2C606.1,536.2,604.5,533.9,602.5,531.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M584.7,550.4l-6-6l-3.5,3.8l9.2,9.2l15.5-15.5l-3.6-3.6L584.7,550.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M946.6,612.4H646.2v6.9h300.4V612.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M845.2,627.6h-199v6.9h199V627.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M602.5,608.3c-3-3-6.8-5-11-5.9c-4.1-0.8-8.5-0.4-12.4,1.2c-3.9,1.6-7.2,4.4-9.6,7.9 c-2.4,3.5-3.6,7.7-3.6,11.9s1.3,8.4,3.6,11.9c2.4,3.5,5.7,6.3,9.6,7.9c3.9,1.6,8.2,2,12.4,1.2c4.1-0.8,8-2.9,11-5.9 c2-2,3.6-4.3,4.7-6.9c1.1-2.6,1.6-5.4,1.6-8.2s-0.6-5.6-1.6-8.2C606.1,612.6,604.5,610.3,602.5,608.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M584.7,626.8l-6-6l-3.5,3.8l0,0l9.2,9.2l15.5-15.5l-3.6-3.6L584.7,626.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M946.6,688.7H646.2v6.9h300.4V688.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M845.2,704h-199v6.9h199V704z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M602.5,684.7c-3-3-6.8-5-11-5.9c-4.2-0.8-8.5-0.4-12.4,1.2c-3.9,1.6-7.3,4.4-9.6,7.9 c-2.4,3.5-3.6,7.7-3.6,11.9s1.3,8.4,3.6,11.9c2.4,3.5,5.7,6.3,9.6,7.9c3.9,1.6,8.2,2,12.4,1.2s8-2.9,11-5.9c2-2,3.6-4.3,4.7-6.9 c1.1-2.6,1.6-5.4,1.6-8.2s-0.6-5.6-1.6-8.2C606.1,689,604.5,686.7,602.5,684.7L602.5,684.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M584.7,703.2l-6-6l-3.5,3.8l9.2,9.2l15.5-15.5l-3.6-3.6L584.7,703.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M946.6,765.1H646.2v6.9h300.4V765.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M845.2,780.4h-199v6.9h199V780.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M602.5,761.1c-3-3-6.8-5-11-5.9c-4.2-0.8-8.5-0.4-12.4,1.2c-3.9,1.6-7.3,4.4-9.6,7.9 c-2.4,3.5-3.6,7.7-3.6,11.9s1.3,8.4,3.6,11.9c2.4,3.5,5.7,6.3,9.6,7.9c3.9,1.6,8.2,2,12.4,1.2s8-2.9,11-5.9c2-2,3.6-4.3,4.6-6.9 c1.1-2.6,1.6-5.4,1.6-8.2s-0.6-5.6-1.6-8.2C606.1,765.4,604.5,763.1,602.5,761.1L602.5,761.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M589.7,764.1c-4.9-1.3-9.3,1.6-9.5,7.9l4.1,0.1c-0.2-3.1,3.9-4.7,5.3-2.8c0.2,0.4,0.4,0.8,0.4,1.2 s-0.1,0.9-0.4,1.2c-2,3.3-6.5,4.4-5.8,9.1h4.6c0.3-5,9.2-7.5,5.2-13.8C592.7,765.6,591.3,764.6,589.7,764.1L589.7,764.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M586.4,783c-0.5,0-1,0.2-1.5,0.4c-0.4,0.3-0.8,0.7-1,1.2s-0.3,1-0.2,1.5s0.4,1,0.7,1.4 c0.4,0.4,0.8,0.6,1.4,0.7c0.5,0.1,1,0.1,1.5-0.1c0.5-0.2,0.9-0.5,1.2-1c0.3-0.4,0.4-1,0.4-1.5c0-0.7-0.3-1.4-0.8-1.9 C587.7,783.3,587.1,783,586.4,783L586.4,783z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M514.9,648.5c0.9,0,1.8-0.3,2.6-0.8s1.4-1.2,1.7-2.1c0.4-0.9,0.4-1.8,0.3-2.7c-0.2-0.9-0.6-1.7-1.3-2.4 s-1.5-1.1-2.4-1.3s-1.8-0.1-2.7,0.3c-0.9,0.4-1.6,1-2.1,1.7c-0.5,0.8-0.8,1.7-0.8,2.6c0,1.2,0.5,2.4,1.4,3.3 C512.5,648,513.7,648.5,514.9,648.5L514.9,648.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M513.1,643.8c0-1,0.3-1.9,0.9-2.7c0.6-0.8,1.4-1.4,2.3-1.7c-0.5-0.2-1-0.3-1.5-0.3c-1.2,0-2.4,0.5-3.3,1.4 c-0.9,0.9-1.4,2.1-1.4,3.3s0.5,2.4,1.4,3.3c0.9,0.9,2.1,1.4,3.3,1.4c0.5,0,1-0.1,1.5-0.3c-0.9-0.3-1.7-0.9-2.3-1.7 C513.5,645.7,513.2,644.8,513.1,643.8L513.1,643.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M514.9,720.9c0.9,0,1.8-0.3,2.6-0.8s1.4-1.2,1.7-2.1c0.4-0.9,0.4-1.8,0.3-2.7c-0.2-0.9-0.6-1.7-1.3-2.4 s-1.5-1.1-2.4-1.3s-1.8-0.1-2.7,0.3c-0.9,0.4-1.6,1-2.1,1.7c-0.5,0.8-0.8,1.7-0.8,2.6c0,1.2,0.5,2.4,1.4,3.3 C512.5,720.4,513.7,720.9,514.9,720.9L514.9,720.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M513.1,716.2c0-1,0.3-1.9,0.9-2.7c0.6-0.8,1.4-1.4,2.3-1.7c-0.5-0.2-1-0.3-1.5-0.3c-1.2,0-2.4,0.5-3.3,1.4 c-0.9,0.9-1.4,2.1-1.4,3.3s0.5,2.4,1.4,3.3c0.9,0.9,2.1,1.4,3.3,1.4c0.5,0,1-0.1,1.5-0.3c-0.9-0.3-1.7-0.9-2.3-1.7 C513.4,718.2,513.1,717.2,513.1,716.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M494.3,822.5l58.4,1.4l-23.3-16.7c-1.9-1.4-3.5-3.2-4.6-5.2c-1.1-2.1-1.8-4.4-1.9-6.8l-0.8-18.3l-31.8,0.1 L494.3,822.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M500.8,801.1v-0.4c-0.1-1,0.2-2,0.8-2.7c0.6-0.8,1.5-1.3,2.5-1.4l18.6-2.7l-0.2-3.7h-31.1l2.8,31l25.5-2.8 l-8.4-3.3c-2.9-1.1-5.4-3-7.2-5.5C502.2,807.1,501.1,804.2,500.8,801.1L500.8,801.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M389.1,821.4h26.3l4.9-44.5l-31.1,0.1L389.1,821.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M395.6,813.9l0.6-13.7c0-0.9,0.4-1.7,1-2.3s1.4-1.1,2.3-1.2l18.9-2.9l0.5-3.8l-29.6,0.1l-0.1,31.5 L395.6,813.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M387.3,426.6v363.6h34.1l29.7-296.5c0.1-0.9,0.5-1.8,1.2-2.4s1.6-1,2.5-1s1.8,0.4,2.5,1s1.1,1.5,1.2,2.4 l31.6,296.5h34.1l-12.3-363.6H387.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M391,805.7l0.8-0.8c3-3,7.1-4.6,11.4-4.5c4.2,0.1,8.3,1.8,11.2,4.8l0.5,0.5c1.5,1.6,2.3,3.6,2.3,5.8v3.4 c0,2,0.3,4,0.9,5.9l2.8,9.2c0.7,2.2,1.1,4.6,1.1,6.9v1.2c0,0.9-0.4,1.7-1.1,2.3s-1.5,0.9-2.4,0.9h-32.3c-0.4,0-0.9,0-1.3-0.2 s-0.8-0.4-1.1-0.7c-0.3-0.3-0.6-0.7-0.8-1.1c-0.2-0.4-0.3-0.8-0.3-1.3v-0.4c0-2.7,0.5-5.4,1.4-8l3.2-9.1c0.8-2.1,1.1-4.3,1.2-6.5 l0.1-2.6C388.7,809.3,389.5,807.3,391,805.7L391,805.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M386.5,790.2h36.4l0.7-7.5h-37L386.5,790.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M386.5,790.2h15.2l0.4-7.5h-15.5L386.5,790.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M382.7,837.7v0.4c0,0.9,0.4,1.7,1.1,2.3s1.5,0.9,2.4,0.9h32.3c0.4,0,0.9-0.1,1.3-0.2c0.4-0.2,0.8-0.4,1.1-0.7 c0.3-0.3,0.6-0.7,0.8-1.1s0.3-0.8,0.3-1.3v-1.1c0-0.4,0-0.9-0.1-1.3h-39.3v2.1L382.7,837.7L382.7,837.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M490.3,812.1v22.8c0,0.9,0.2,1.7,0.5,2.5s0.8,1.6,1.4,2.2c0.6,0.6,1.4,1.1,2.2,1.5c0.8,0.3,1.7,0.5,2.6,0.5 h77.4c0.7,0,1.4-0.3,2-0.8c0.5-0.5,0.8-1.2,0.8-2c0-2.7-0.8-5.2-2.4-7.4c-1.6-2.2-3.7-3.8-6.3-4.6L551,821l-22.1-17.2 c-1.1-0.9-2.5-1.3-3.9-1.3s-2.8,0.5-3.8,1.5l-9.8,8.4c-0.7,0.6-1.6,1-2.5,1.2s-1.9,0.2-2.8-0.1l-12.4-3.9c-0.4-0.1-0.8-0.2-1.2-0.1 s-0.8,0.2-1.1,0.5c-0.3,0.2-0.6,0.6-0.8,0.9C490.4,811.3,490.3,811.7,490.3,812.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.9,841.6h77.4c0.7,0,1.4-0.3,2-0.8s0.8-1.2,0.8-2c0-0.9-0.1-1.9-0.4-2.8h-86.4c0.3,1.6,1.1,3,2.3,4 C493.8,841,495.3,841.5,496.9,841.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M510.6,786.1l-33.7-279.9c-0.5-4.3-2.6-8.3-5.9-11.2c-3.3-2.9-7.5-4.5-11.9-4.5h-4.2c0.9,0,1.8,0.4,2.5,1 s1.1,1.5,1.2,2.4L490,788.8L510.6,786.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M489.4,790.2h36.3l-0.5-7.5h-36.5L489.4,790.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M421.2,258.1h51.7v190.1h-49.2L421.2,258.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M489.4,790.2H511l-0.8-7.5h-21.5L489.4,790.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M431.2,263.1c5,3.3,10.8,5,16.8,4.8s11.7-2.2,16.5-5.8l0,0c0.5-0.4,0.9-0.9,1.1-1.5s0.3-1.2,0.2-1.9 l-2.2-20.3c0.5-2,0.7-4,0.7-6c0.3-10.3,1.2-19.5,1.2-19.5s-34-21.4-35.4,4.8l-0.5,6.8l-2.3,34.2c0,0.9,0.3,1.9,0.9,2.6L431.2,263.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M468.6,214.5c2.3,0,4.5-0.7,6.4-1.9c1.9-1.3,3.4-3.1,4.2-5.2c0.9-2.1,1.1-4.4,0.7-6.7 c-0.4-2.2-1.5-4.3-3.2-5.9c-1.6-1.6-3.7-2.7-5.9-3.1s-4.5-0.2-6.7,0.7c-2.1,0.9-3.9,2.4-5.2,4.2c-1.3,1.9-1.9,4.1-1.9,6.4 c0,3,1.2,6,3.4,8.1C462.6,213.3,465.5,214.5,468.6,214.5L468.6,214.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M471.7,196.2c0,0,7.5,51.6-18.8,52.6c-22.7,1-22-34.2-22-34.2L434,192L471.7,196.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M467.9,197.6l-23,1.7c-1.4,0.1-2.6,0.8-3.5,1.8s-1.4,2.4-1.3,3.8c0,0.7,0,1.4-0.3,2c-0.2,0.7-0.6,1.3-1,1.8 s-1,0.9-1.6,1.3c-0.6,0.3-1.3,0.5-2,0.5c-0.4,0-0.7,0.2-0.9,0.5s-0.4,0.6-0.4,1l0.3,5.1c0,0.2,0,0.3,0,0.5s-0.1,0.3-0.2,0.4 c-0.1,0.1-0.2,0.2-0.4,0.3c-0.1,0.1-0.3,0.1-0.5,0.1c-0.3,0-0.6-0.1-0.8-0.2s-0.4-0.4-0.5-0.7l-1-4.8l-1-1.6l-5.4,3.3 c0,0-8.8-13.5-4.6-25.9c2.4-7,9.3-9.5,12.7-9.9c0.5-0.1,1-0.3,1.5-0.6c0.4-0.3,0.8-0.7,1.1-1.1c1.3-2.2,4.6-6.2,11.8-5.9 c2,0,4.1,0.5,5.9,1.5s3.3,2.4,4.4,4.1c0.5,0.7,1.2,1.2,2,1.4s1.7,0.2,2.4-0.2c1.6-0.7,3.3-1,5-0.9s3.4,0.7,4.8,1.6 C478.9,183.4,475.9,196.4,467.9,197.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M429.7,226.1c1.2,0.1,2.3-0.2,3.3-0.8l-3.7,5.7L429.7,226.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M431,212.6c-0.2-0.6-0.6-1.2-1.1-1.7s-1-0.9-1.7-1.1c-0.6-0.2-1.3-0.4-2-0.3c-0.7,0-1.3,0.2-1.9,0.6 c-5.7,2.5-4.5,15.3,5.1,16.1c5,0.4,4-2.5,3.2-6.4L431,212.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M424,213.3c0.8-0.6,1.8-0.9,2.8-0.8c0.5,0.1,0.9,0.3,1.3,0.6s0.7,0.7,0.9,1.1c0.6,1.1,0.9,2.3,0.9,3.5 l0.1,1.1c0,0.1-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.3-0.1-0.4-0.1c-0.1-0.1-0.2-0.2-0.2-0.4l-0.1-1.1 c0-1-0.3-2-0.8-2.9c-0.3-0.6-0.8-1-1.4-1.2c-0.7-0.1-1.3,0.1-1.8,0.5c-0.1,0.1-0.3,0.1-0.4,0.1s-0.3-0.1-0.4-0.2 C423.7,213.9,423.8,213.6,424,213.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M465.3,252.7l-0.8-8.2c-2.2,2.2-8.4,5.5-15.5,3.8c-3.6-0.9-6.7-2.9-9.1-5.7c0-0.1-0.1-0.1-0.2-0.1 s-0.1-0.1-0.2-0.1s-0.1,0-0.2,0s-0.1,0.1-0.2,0.1s-0.1,0.1-0.1,0.2s-0.1,0.1-0.1,0.2s0,0.1,0,0.2s0.1,0.1,0.1,0.2 c3.1,3.6,7.3,5.9,12,6.4c2.1,1.4,4.4,2.4,6.8,2.9C460.3,253.2,462.9,253.2,465.3,252.7z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M457.4,238.3C457.4,238.3,457.3,238.3,457.4,238.3c-2.2,0.2-3.2,0.2-3.2,0.2c-0.2,0-0.4-0.1-0.5-0.2 s-0.2-0.3-0.2-0.5c0-0.1,0-0.2,0-0.3s0.1-0.2,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0,0.2-0.1,0.3-0.1l3.1-0.2 c0.4,0,0.8,0.2,0.8,0.6C458,237.9,457.7,238.3,457.4,238.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M458.5,235.3c-5.7,0.8-8.2-2.2-9.2-3.8c0-0.1-0.1-0.2-0.1-0.2c0-0.1,0-0.2,0-0.3c0-0.2,0.2-0.3,0.3-0.4 c0.2-0.1,0.3-0.1,0.5-0.1s0.3,0.2,0.4,0.3c0.8,1.5,3.7,4.8,10.5,2.5c0.2,0,0.3,0,0.5,0.1s0.3,0.2,0.3,0.4s0,0.3-0.1,0.5 s-0.2,0.3-0.4,0.3C460.5,234.9,459.5,235.1,458.5,235.3L458.5,235.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M450.7,221.9c0.4,0,0.8-0.1,1.2-0.3c0.3-0.2,0.6-0.6,0.8-0.9c0.2-0.4,0.2-0.8,0.1-1.2s-0.3-0.8-0.6-1.1 c-0.3-0.3-0.7-0.5-1.1-0.6s-0.8,0-1.2,0.1c-0.4,0.2-0.7,0.4-0.9,0.8c-0.2,0.3-0.3,0.8-0.3,1.2c0,0.6,0.2,1.1,0.6,1.5 C449.6,221.7,450.2,221.9,450.7,221.9L450.7,221.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M451.6,220.4c0.1,0,0.2,0,0.3-0.1s0.1-0.2,0.1-0.3s0-0.1,0-0.2s-0.1-0.1-0.1-0.1l-0.1-0.1c-0.1,0-0.1,0-0.2,0 s-0.2,0-0.3,0.1s-0.1,0.2-0.1,0.3s0,0.1,0,0.2s0,0.1,0.1,0.1l0.1,0.1C451.5,220.4,451.6,220.4,451.6,220.4L451.6,220.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M467.2,222c0.4,0,0.8-0.1,1.2-0.4c0.3-0.2,0.6-0.6,0.8-0.9c0.2-0.4,0.2-0.8,0.1-1.2s-0.3-0.8-0.6-1.1 c-0.3-0.3-0.7-0.5-1.1-0.6s-0.8,0-1.2,0.1c-0.4,0.2-0.7,0.4-0.9,0.8c-0.2,0.3-0.4,0.7-0.4,1.2c0,0.6,0.2,1.1,0.6,1.5 S466.7,222,467.2,222L467.2,222z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M468.1,220.5c0.1,0,0.1,0,0.2,0s0.1-0.1,0.1-0.1l0.1-0.1c0-0.1,0-0.1,0-0.2s0-0.2-0.1-0.3s-0.2-0.1-0.3-0.1 s-0.1,0-0.2,0l-0.1,0.1l-0.1,0.1c0,0.1,0,0.1,0,0.2s0,0.2,0.1,0.3C467.9,220.4,468,220.5,468.1,220.5L468.1,220.5z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M460.1,230.2l-2.8,0.2c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.2-0.2-0.4s0.1-0.3,0.2-0.4 c0.1-0.1,0.2-0.2,0.4-0.2l2.8-0.2c0.3,0,0.6-0.2,0.9-0.4c0.2-0.2,0.3-0.6,0.3-0.9s-0.2-0.6-0.4-0.8c-0.2-0.2-0.6-0.3-0.9-0.3 c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3-0.2-0.4c-0.1-0.3,0.2-0.6,0.6-0.7c0.6,0,1.3,0.2,1.8,0.6s0.8,1,0.9,1.7 c0,0.7-0.2,1.3-0.6,1.8C461.3,229.8,460.7,230.1,460.1,230.2L460.1,230.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M473.3,213.2l-9.1-0.3H463l-7.9-0.2H455l-10.2-0.3c-0.4,0-0.8,0.1-1.2,0.2s-0.7,0.4-1,0.6 c-0.3,0.3-0.5,0.6-0.7,1s-0.3,0.7-0.3,1.1l-0.1,2.3c-0.1,2.2,0.7,4.3,2.2,5.8s3.5,2.5,5.7,2.6s4.3-0.7,5.8-2.2 c1.6-1.5,2.5-3.5,2.6-5.7l0.1-2.3c0-0.7-0.2-1.3-0.6-1.9l3.2,0.1c-0.4,0.5-0.6,1.2-0.6,1.8l-0.1,2.3c-0.1,1.1,0.1,2.2,0.5,3.2 s0.9,2,1.7,2.8c0.7,0.8,1.6,1.4,2.6,1.9c1,0.4,2.1,0.7,3.1,0.7c1.1,0,2.2-0.2,3.2-0.5c1-0.4,1.9-1,2.7-1.7c0.8-0.8,1.4-1.7,1.8-2.7 s0.7-2.1,0.7-3.2l0.1-2.3c0-0.4,0-0.8-0.2-1.2c-0.1-0.4-0.3-0.7-0.6-1s-0.6-0.5-1-0.7C474.1,213.4,473.7,213.3,473.3,213.2 L473.3,213.2z M456.8,215.8l-0.1,2.3c-0.2,1.7-1.1,3.3-2.4,4.4c-1.3,1.1-3,1.7-4.7,1.7s-3.4-0.7-4.6-1.9c-1.3-1.2-2-2.8-2.2-4.5 l0.1-2.3c0-0.5,0.2-0.9,0.6-1.3c0.4-0.3,0.8-0.5,1.3-0.5L455,214h0.1c0.5,0,0.9,0.2,1.2,0.5C456.7,214.8,456.8,215.3,456.8,215.8 L456.8,215.8z M475,218.6c-0.2,1.7-1.1,3.3-2.4,4.4c-1.3,1.1-3,1.7-4.7,1.7s-3.4-0.7-4.7-1.9c-1.3-1.2-2-2.8-2.2-4.6l0.1-2.3 c0-0.5,0.2-0.9,0.6-1.3c0.4-0.3,0.8-0.5,1.3-0.5h1.2l9.1,0.3c0.5,0,0.9,0.2,1.3,0.6c0.3,0.4,0.5,0.8,0.5,1.3L475,218.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M462.1,287.3l-1.6,178.9c0,0.8,0.1,1.6,0.5,2.4c0.3,0.8,0.8,1.5,1.3,2c0.6,0.6,1.3,1,2,1.4 c0.8,0.3,1.6,0.5,2.4,0.5h47.1v-26.8L462.1,287.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M439.5,287.8l-24.2,148.8v18.3l-28.1-0.3v328l14.7,0.1l13.3-285.8l0.3-8.2c0.1-2.3,1-4.4,2.5-6.1 s3.5-2.8,5.7-3.2l11.6-1.9c0.9,0,1.7-0.2,2.5-0.5s1.5-0.8,2.1-1.4s1.1-1.3,1.4-2.1c0.3-0.8,0.5-1.7,0.5-2.5L439.5,287.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M482.9,262.3l36.1,8.3c4.4,1,8.4,3.3,11.5,6.5c3.1,3.3,5.2,7.3,6,11.8l19,98.5l-37.1-3.8l-1.6,83.7 c0,0.8-0.3,1.6-0.9,2.1c-0.6,0.6-1.3,0.9-2.1,0.9h-45c-0.8,0-1.6-0.3-2.1-0.9c-0.6-0.6-0.9-1.3-0.9-2.1l-4.1-179.6L482.9,262.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M482.9,262.3l36.1,8.3c4.4,1,8.4,3.3,11.5,6.5c3.1,3.3,5.2,7.3,6,11.8l19,98.5l-37.1-3.8l-1.6,83.7 c0,0.8-0.3,1.6-0.9,2.1c-0.6,0.6-1.3,0.9-2.1,0.9h-45c-0.8,0-1.6-0.3-2.1-0.9c-0.6-0.6-0.9-1.3-0.9-2.1l-4.1-179.6L482.9,262.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M417.4,262.3l-37.2,8.3c-4.5,1-8.6,3.4-11.8,6.7c-3.2,3.4-5.2,7.6-5.9,12.2l-15.6,102.4 c-0.1,0.7-0.2,1.5-0.1,2.2c0.3,7.8,8,13.1,15.5,11.1l5.9-1.6l14.6-5l0.8,68.7c0,0.8,0.3,1.6,0.9,2.1c0.6,0.6,1.3,0.9,2.1,0.9h46.5 c0.8,0,1.6-0.3,2.1-0.9c0.6-0.6,0.9-1.3,0.9-2.1l3.3-179.6L417.4,262.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M433.1,283.9v50"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M468.6,279.9v53.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M464.5,247.5c0,0,21.5,5.3,18,18c-0.5,1.7-1.4,3.3-2.5,4.6c-5.5,6.4-11.6,12.3-18.2,17.6l4.6-26.6 L464.5,247.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M427.6,247.5c0,0-24.1,6.1-15.9,21.1c0,0,2.4,6.7,27.8,20l-12.1-28.3L427.6,247.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M427.6,247.5c0,0-24.1,6.1-15.9,21.1c0,0,2.4,6.7,27.8,20l-12.1-28.3L427.6,247.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M464.5,247.5c0,0,21.5,5.3,18,18c-0.5,1.7-1.4,3.3-2.5,4.6c-5.5,6.4-11.6,12.3-18.2,17.6l4.6-26.6 L464.5,247.5z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M374.7,312.4c1.3,0.9,2.5,1.9,3.4,3.2c1,1.2,1.8,2.6,2.5,3.9c0.7,1.4,1.3,2.8,1.8,4.3s0.8,3,1,4.6 c-0.8-1.3-1.5-2.7-2.2-4.1c-0.4-0.7-0.7-1.4-1-2s-0.7-1.3-1-2c-0.7-1.3-1.4-2.7-2.1-4C376.4,315,375.5,313.7,374.7,312.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M518.8,350.7v-38.4l7.8,40c1.3,6.5,5,12.2,10.3,16l17.2,12.3l1.4,7.7l-31-9.4l-6-28.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M530,357.8c0,0,2.5-3.3,3.3,0l-0.8,15l-4.2-10L530,357.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M530,357.8c0,0,2.5-3.3,3.3,0l-0.8,15l-4.2-10L530,357.8z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M524.6,286.5c-0.7,2-1.3,4-1.8,6s-0.9,4-1.3,6.1c-0.8,4.1-1.4,8.2-2,12.2l-1.5-0.2c0.5-2.2,1.3-4.4,2.2-6.5 c0.5-1,1-2,1.6-3s1.4-1.8,2.3-2.5c-0.8,0.8-1.4,1.7-1.8,2.8c-0.5,1-0.8,2-1.2,3.1c-0.3,1.1-0.7,2.1-0.9,3.2s-0.5,2.2-0.8,3.2 l-1.5-0.2c0.2-2.1,0.5-4.2,0.8-6.2c0.3-2.1,0.8-4.1,1.3-6.1c0.2-1,0.5-2,0.8-3l0.5-1.5l0.5-1.5 C522.6,290.3,523.5,288.3,524.6,286.5L524.6,286.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M383,410.6l0.7,56.7c0,0.8,0.3,1.6,0.9,2.1c0.6,0.6,1.3,0.9,2.1,0.9h9.9l-0.5-78.4l-6-22l-5.3-55.7 c0-0.2-0.1-0.3-0.2-0.4s-0.3-0.2-0.4-0.1c-0.2,0-0.3,0.1-0.4,0.2s-0.2,0.3-0.2,0.4L383,410.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M554.6,385.3c1.2,0.6,2.2,1.5,2.9,2.6s1.1,2.4,1.1,3.7c0.5,7.4-3.5,24.4-23.1,20c-1.2-0.3-4.4-1.6-3.7-3.7 v-0.1L554.6,385.3z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M554.6,385.3c1.2,0.6,2.2,1.5,2.9,2.6s1.1,2.4,1.1,3.7c0.5,7.4-3.5,24.4-23.1,20c-1.2-0.3-4.4-1.6-3.7-3.7 v-0.1L554.6,385.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M532.5,372.8l20.4,10.9c1.8,1,2.6,3,2.9,5.1c0.8,6.3-3.3,25.7-22,20.5c-1.4-0.4-2.6-1.2-3.4-2.3l-12.9-16.7 L532.5,372.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M524.9,388.4c3.4-2.8,6.9-7.8,8-15.2l-1.7-0.8l-15.8,15.8l2.1,2.1l12.9,16.7c0.9,1.1,2.1,1.9,3.4,2.3 c13.6,3.7,19.5-5.5,21.4-13.2c-9.1,16.7-25,1.9-30.6-4c-0.2-0.3-0.4-0.6-0.5-0.9s-0.2-0.7-0.1-1c0-0.4,0.1-0.7,0.3-1 S524.6,388.7,524.9,388.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M537.8,343.2H519c-0.3,0-0.7,0.1-1,0.2c-0.3,0.2-0.5,0.4-0.7,0.7l-22,34.6c-0.1,0.1-0.1,0.3-0.1,0.4 s0,0.3,0.1,0.4s0.2,0.2,0.3,0.3s0.3,0.1,0.4,0.1l20.5,0.8l22-36.3c0.1-0.1,0.1-0.2,0.1-0.4c0-0.1,0-0.3-0.1-0.4s-0.2-0.2-0.3-0.3 C538.1,343.3,537.9,343.2,537.8,343.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M537.8,343.2h-19.5c-0.1,0-0.3,0-0.4,0.1c-0.1,0.1-0.2,0.2-0.3,0.3l-22.3,35.2c-0.1,0.1-0.1,0.3-0.1,0.4 s0,0.3,0.1,0.4s0.2,0.2,0.3,0.3s0.3,0.1,0.4,0.1l20.5,0.8l22-36.3c0.1-0.1,0.1-0.3,0.1-0.4s0-0.3-0.1-0.4s-0.2-0.2-0.3-0.3 C538.1,343.2,537.9,343.2,537.8,343.2L537.8,343.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M538.4,344.4h-18.8c-0.3,0-0.5,0.1-0.7,0.2s-0.4,0.3-0.5,0.5l-22.1,34.8l22.9,1.2L538.4,344.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M524.3,370.7c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.2,0-0.5,0-0.7l-1.3-5.9l-5.1-9.8c-0.2-0.5-0.2-1.1,0-1.6 s0.6-0.9,1.1-1.2c0.4-0.2,0.9-0.2,1.4-0.1s0.8,0.4,1.1,0.8l7.4,10.3l3.3,10.8c-3.3,10-15,17.5-15,17.5h-3c-1.9,0-3.7-0.6-5.2-1.6 l-6.4-4.5c-1.3-0.9-2.4-2.2-3.1-3.7l-3.4-7.4c-0.2-0.4-0.2-0.8-0.2-1.1c0.1-0.4,0.3-0.7,0.5-1c0.2-0.2,0.4-0.3,0.7-0.4 c0.3-0.1,0.5-0.1,0.8-0.1s0.5,0.1,0.8,0.2c0.2,0.1,0.5,0.3,0.6,0.5l4.5,5.8l5.4,4.6c0.1,0.1,0.3,0.2,0.5,0.2s0.4,0,0.5-0.1h0.1 c0.1-0.1,0.2-0.1,0.3-0.3c0.1-0.1,0.1-0.2,0.2-0.4c0-0.1,0-0.3,0-0.4s-0.1-0.3-0.2-0.4l-6-8.3l-3.5-9.2c-0.2-0.4-0.2-0.9,0-1.4 c0.2-0.4,0.5-0.8,0.9-1l0.2-0.1c0.4-0.2,0.9-0.3,1.4-0.1c0.5,0.1,0.9,0.4,1.1,0.8l4.9,7.7l6.2,5.4c0.1,0.1,0.3,0.2,0.5,0.2 s0.4,0,0.5-0.1l0.2-0.1c0.2-0.1,0.4-0.3,0.5-0.6c0.1-0.2,0.1-0.5-0.1-0.7l-3.7-6.6l-5.6-7.6c-0.3-0.4-0.4-0.9-0.4-1.4 c0.1-0.5,0.3-1,0.8-1.3l0,0c0.5-0.4,1.1-0.6,1.8-0.5c0.6,0,1.2,0.3,1.7,0.7l6.7,6.8l3.8,7.6c0.1,0.2,0.3,0.4,0.6,0.5 C523.8,370.9,524.1,370.9,524.3,370.7L524.3,370.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M383.2,361.2l63-16.3l27.3-10.9c1.2-0.5,2.6-0.6,3.9-0.2l12.8,3.6c1,0.3,1.8,0.8,2.6,1.5l8,8 c0.2,0.2,0.4,0.5,0.5,0.8s0.2,0.6,0.1,0.9c0,0.3-0.1,0.6-0.3,0.9c-0.2,0.3-0.4,0.5-0.6,0.7c-0.4,0.3-0.8,0.4-1.3,0.4 s-0.9-0.2-1.3-0.4l-8.7-6.5l-7.5-2.2c-0.2-0.1-0.5-0.1-0.8,0c-0.2,0.1-0.4,0.3-0.5,0.5l0,0c-0.1,0.2-0.1,0.5-0.1,0.8 c0.1,0.3,0.2,0.5,0.4,0.6l9.5,6.8c0.4,0.3,0.7,0.7,0.9,1.2s0.2,1,0,1.5s-0.5,1-1,1.3l-0.7,0.5c-0.3,0.2-0.7,0.4-1.1,0.4 s-0.8,0-1.2-0.2l-3-1.2l1.2,0.8c0.4,0.3,0.7,0.6,0.8,1.1c0.1,0.4,0.1,0.9,0,1.3c-0.1,0.3-0.3,0.6-0.5,0.8s-0.5,0.4-0.8,0.5 l-0.9,0.3c-0.4,0.1-0.8,0.1-1.2,0l-5.2-1.5l4.5,1.9c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.2,0.3,0.3,0.5s0.1,0.4,0.1,0.5 c0,0.2-0.1,0.4-0.1,0.5l0,0c-0.1,0.3-0.3,0.5-0.6,0.6l-1.3,0.6c-1.1,0.5-2.3,0.8-3.4,0.6l-5.7-0.6c0,0-7.5,1.7-19.2,0.8l-65.9,33.4 L374.1,382L383.2,361.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M367.4,362.8c0,0,9.2-3.3,15.8-3.3c0,0-1.7,34.2,3.3,36.7c0,0-9.2,7.8-18.4,7.7 C368.2,403.8,364.9,396.2,367.4,362.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M370.1,361.9c4-1.3,8.2-2.1,12.4-2.5c0.1,0,0.2,0,0.3,0.1s0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.2,0.3 c0,0.1,0.1,0.2,0,0.3c-0.2,5.2-1.2,33.6,3.4,35.9c0,0-9.2,7.8-18.4,7.7c0,0-6.6-11.5-1.4-38.3c0.2-0.8,0.5-1.6,1.1-2.2 C368.5,362.6,369.3,362.2,370.1,361.9L370.1,361.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M482.1,359.9c0,3.3-10.8,0-10.8,0c-5,0-20-2.5-20-2.5l-67.8,27.2l1,9.1l2.2,2.5l65.9-33.4 c11.7,0.8,19.2-0.8,19.2-0.8l5.7,0.6c1.2,0.1,2.4-0.1,3.4-0.6l1.3-0.7c0.3-0.1,0.5-0.3,0.6-0.6l0,0L482.1,359.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M383.7,384.9c-38.4,17.5-35.8,0.4-35.8,0.4l-1,6.6c-0.1,0.7-0.2,1.5-0.1,2.2c0.3,7.8,8,13.1,15.5,11.1l5.9-1.6 l14.6-5v0.1l4.2-2.2C383.7,394.9,383.7,384.9,383.7,384.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M484.8,353.9l-6.9-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M480,358l-5.4-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M397.2,397.9h23.7c0.6,0,1.1,0.2,1.5,0.6s0.6,0.9,0.6,1.5v25c0,1.6-0.6,3.1-1.7,4.2s-2.6,1.7-4.2,1.7H401 c-1.6,0-3.1-0.6-4.2-1.7s-1.7-2.6-1.7-4.2v-24.9c0-0.6,0.2-1.1,0.6-1.5C396.1,398.2,396.6,397.9,397.2,397.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M479.2,397.9h23.7c0.6,0,1.1,0.2,1.5,0.6s0.6,0.9,0.6,1.5v25c0,1.6-0.6,3.1-1.7,4.2s-2.6,1.7-4.2,1.7H483 c-1.6,0-3.1-0.6-4.2-1.7s-1.7-2.6-1.7-4.2v-24.9c0-0.6,0.2-1.1,0.6-1.5C478.1,398.2,478.6,397.9,479.2,397.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1168.1,73.4h-57.8c-3.1,0-5.6,2.5-5.6,5.6v26.8c0,3.1,2.5,5.6,5.6,5.6h57.8c3.1,0,5.6-2.5,5.6-5.6V79 C1173.7,75.9,1171.2,73.4,1168.1,73.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1168.1,73.4h-57.8c-3.1,0-5.6,2.5-5.6,5.6v26.8c0,3.1,2.5,5.6,5.6,5.6h57.8c3.1,0,5.6-2.5,5.6-5.6V79 C1173.7,75.9,1171.2,73.4,1168.1,73.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1162.1,73.4h-57.8c-3.1,0-5.6,2.5-5.6,5.6v26.8c0,3.1,2.5,5.6,5.6,5.6h57.8c3.1,0,5.6-2.5,5.6-5.6V79 C1167.7,75.9,1165.2,73.4,1162.1,73.4z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1113.4,98c3.1,0,5.6-2.5,5.6-5.6s-2.5-5.6-5.6-5.6s-5.6,2.5-5.6,5.6S1110.3,98,1113.4,98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1133.2,98c3.1,0,5.6-2.5,5.6-5.6s-2.5-5.6-5.6-5.6s-5.6,2.5-5.6,5.6S1130.1,98,1133.2,98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1153,98c3.1,0,5.6-2.5,5.6-5.6s-2.5-5.6-5.6-5.6s-5.6,2.5-5.6,5.6S1150,98,1153,98z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1108.6,111.4l0.1,12l15-15L1108.6,111.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1100.7,94.5v-14c0-0.6,0.1-1.2,0.3-1.7c0.2-0.5,0.5-1,1-1.4s0.9-0.7,1.4-1c0.5-0.2,1.1-0.3,1.7-0.3l45.6,0.3 l-43.6,2.8c-1,0.1-1.9,0.5-2.6,1.1s-1.2,1.5-1.4,2.4L1100.7,94.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st23",
    cx: 654.7,
    cy: 214.7,
    r: 30.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M882.2,199.5H711.8v6.9h170.4L882.2,199.5L882.2,199.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M930.1,216H711.7v6.9h218.4V216z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M960.5,354.2h-346v6.9h346.1L960.5,354.2L960.5,354.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M784.8,339.7H614.5v6.9h170.4L784.8,339.7L784.8,339.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M960.5,402.6h-346v6.9h346.1L960.5,402.6L960.5,402.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M784.8,388.1H614.5v6.9h170.4L784.8,388.1L784.8,388.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphoneMannServiceweltCombi);
export default __webpack_public_path__ + "static/media/Smartphone_Mann_Servicewelt_combi.1ec4bf448c939fbc7abd70249b1e1010.svg";
export { ForwardRef as ReactComponent };